<template>
  <div class="component mt-3 px-4">
    <div class="card bg-white border-0 rounded-0">
      <div class="card-body">
        <h1 v-text="this.$ml.get(this.g_query_header)"></h1>
        <entry-table :items="this.g_last_query"></entry-table>
      </div>
    </div>
  </div>
</template>
<script>
import EntryTable from "./TableSearch";
import { mapGetters } from "vuex";
export default {
  components: { EntryTable },
  computed: mapGetters(["g_last_query", "g_query_header"]),
};
</script>
